Controller = App.loadClass 'core::Angular/Controller'

class exports.SelectSurveysController extends Controller

    constructor: (@scope, @transitions, @repo, @modal) ->
        super(@scope, @transitions)

        @scope.step.title = 'Select Surveys'
        @scope.step.previous = @previous
        @scope.step.next = @next
        @scope.step.canContinue = @canContinue

        # stuff for survey results
        @scope.placeholder = 'Loading survey results...'
        @scope.survey_results = []
        @scope.showSurveyFields = @showSurveyFields
        @scope.selectAllSurveyResults = @selectAllSurveyResults
        @scope.toggleSurveyResult = @toggleSurveyResult
        @scope.isSurveyResultSelected = @isSurveyResultSelected
        @scope.numPlans = (sr) => Object.keys(sr.planned_fields).length

        # initialize check for input changes
        @input_changed = false
        @scope.$watchCollection 'selected.survey_results', (val, old_val) =>
            if val isnt old_val
                @input_changed = true

        # load data
        @loadSurveyResults()

    loadSurveyResults: () =>
        @repo.getSurveyResults(@scope.selected.years, @scope.selected.spps).then (result) =>
            if result.data?.status?.type isnt 'success'
                if result.data?.status?
                    @scope.$parent.setAlert(result.data.status)
                else
                    @scope.$parent.setAlert
                        type: 'error'
                        msg: 'Failed to load survey results'
                return

            @scope.survey_results = result.data.data.survey_results
            if @scope.survey_results.length is 0
                @scope.placeholder = 'No survey results found'
            else
                # pre-select all of them (copy the array)
                if @scope.selected.survey_results.length is 0
                    @selectAllSurveyResults()

            @sanityCheck()

        , () =>
            # if the request failed
            @scope.$parent.setAlert
                type: 'error'
                msg: 'Failed to load survey results'

    sanityCheck: () =>
        # this is just to make absolutely sure we don't have bad values
        # selected that aren't actually options (reverse for loop because we're
        # deleting things)
        for survey_result in @scope.selected.survey_results by -1
            if _.findIndex(@scope.survey_results, { id: survey_result.id }) is -1
                @toggleSurveyResult(survey_result)

    previous: () =>
        @scope.$parent.clearAlert()
        @scope.goToStep('select_year_and_crop')

    next: () =>
        @scope.$parent.clearAlert()
        if @input_changed
            @scope.selected.duplicate_fields = []

        if @hasDuplicateFields()
            @scope.goToStep('duplicate_fields')
        else
            @repo.launchPsr(@scope.selected, @scope.step)

    canContinue: () =>
        return @scope.selected.survey_results.length > 0

    hasDuplicateFields: () =>
        unique_field_ids = []

        # get the unique field IDs that are already selected
        for sr in @scope.selected.survey_results
            unique_field_ids[sr.year] ?= []

            for id, layer_id of sr.planned_fields
                if id in unique_field_ids[sr.year]
                    return true
                else
                    unique_field_ids[sr.year].push id

        return false

    showSurveyFields: (survey_result) =>
         # launch the dialog
        modal_instance = @modal.open
            windowClass: 'small_dialog'
            templateUrl: 'backend/grower/placement/survey-fields-dialog'
            controller: 'Placement.Controllers.SurveyFieldsDialogController'
            scope: @scope
            resolve:
                'survey_result': -> survey_result

    selectAllSurveyResults: () =>
        if @scope.survey_results.length is 0
            return

        # This is a bit more painful than just selecting all, because we're
        # limited to 50 unique fields, which means we have to check each survey
        # result before selecting it.. The "deselect all" functionality also
        # gets pretty interesting. So here we go..

        # First get all selectable survey results
        selectable_survey_results = []
        for survey_result in @scope.survey_results
            if @checkUniqueFieldLimit(survey_result, selectable_survey_results) is true
                selectable_survey_results.push(survey_result)

        # If all *selectable* survey results are selected, then deselect all
        if @allSurveyResultsAreSelected(selectable_survey_results)
            @scope.selected.survey_results = []
        else
            @scope.selected.survey_results = selectable_survey_results
            if @scope.selected.survey_results.length < @scope.survey_results.length
                @scope.$parent.setAlert
                    type: 'error'
                    msg: 'Due to export size limitations, the Placement Report cannot include
                    more than 50 fields at a time. Since you have created planting plans for more than 50 fields,
                    not all of your surveys can be selected at this time.
                    (Hint: You can run multiple batches if needed.)'

    toggleSurveyResult: (survey_result) =>
        i = _.findIndex(@scope.selected.survey_results, { id: survey_result.id })
        if i is -1
            # survey result is not selected. add it to the array
            # but make sure it can be selected first
            num = @checkUniqueFieldLimit(survey_result)
            if num is true
                @scope.selected.survey_results.push(survey_result)
            else
                @scope.$parent.setAlert
                    type: 'error'
                    msg: "Due to export size limitations, the Placement Report cannot include more than
                    50 fields at a time. Since you have already selected #{num} fields that have planting plans,
                    this survey cannot be selected at this time."
                , [], 10000
        else
            # survey result is selected. remove it from the array
            @scope.selected.survey_results.splice(i, 1)

    checkUniqueFieldLimit: (survey_result, selected_survey_results = null) =>
        unique_field_ids = []
        selected_survey_results ?= @scope.selected.survey_results

        # get the unique field IDs that are already selected
        for sr in selected_survey_results
            for id, layer_id of sr.planned_fields
                if id not in unique_field_ids
                    unique_field_ids.push id

        # see if this survey result will put us over the 50 field limit
        num_selected_fields = unique_field_ids.length
        num_new_fields = 0
        for id, layer_id of survey_result.planned_fields
            if id not in unique_field_ids
                num_new_fields += 1

                # if it does, it can't be selected
                if num_selected_fields + num_new_fields > 50
                    return num_selected_fields

        return true

    allSurveyResultsAreSelected: (survey_results) =>
        for survey_result in survey_results
            if not @isSurveyResultSelected(survey_result)
                return false

        return true

    isSurveyResultSelected: (survey_result) =>
        return _.findIndex(@scope.selected.survey_results, { id: survey_result.id }) > -1
